import { render } from "./Storage.vue?vue&type=template&id=6e581657&scoped=true"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"

import "./Storage.vue?vue&type=style&index=0&id=6e581657&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e581657"]])

export default __exports__